module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_8023.c9472455.png";